"use strict";

module.exports = ['$rootScope', '$http', '$q', '$timeout', 'MaterialSvc', 'ForecastSvc', function ($root, $http, $q, $timeout, MaterialSvc, ForecastSvc) {

    const ESTIMATE_PRESETS = [2, 3, 3, 5, 5, 7, 14, 16, 16, 17, 10, 2];

    class OrderPlanMaterialEntry {
        constructor(order_plan_material, json_data={}) {
            this.order_plan_material = order_plan_material;
            this.order_plan = order_plan_material.order_plan;
            this.months = [];
            this.hasEstimates = false;
            this.total_estimate_calculated = -1;
            this.total_estimate_input = "";
            this.total_scheduled = 0;

            this.unit_cost = 0;
            this.total_revenue_estimated = 0;
            this.total_revenue_scheduled = 0;

            this.generateMonths();
            this.loadFromJson(json_data);
        }

        generateMonths() {
            this.months = [];
            for (var i = this.order_plan_material.order_plan.startFrom; i <= 12 - 1; i++) {
                this.months.push({
                    input: "-",
                    parsed_input: 0,
                    scheduled: 0,
                    scheduled_revenue: 0,
                    calculated_revenue: 0
                });
            }
        }

        createEstimates() {
            var total_estimate = parseInt(this.total_estimate_input) || 0;
            var estimates = this.order_plan_material.order_plan.sales_distribution.estimates;
            for (var i = this.order_plan_material.order_plan.startFrom; i < 12; i++) {
                this.months[i].input = `${Math.round(total_estimate * estimates[i].percentage / 100)}`;
            }
            this.hasEstimates = true;
            this.updateTotals();
        }

        clearEstimates() {
            if(!this.hasEstimates) return;

            this.hasEstimates = false;
            this.total_estimate_input = this.total_estimate_calculated;
            for (var i = 0; i < 12; i++) {
                this.months[i].input = 0;
                this.months[i].parsed_input = 0;
            }
            this.updateTotals();
        }

        updateTotals(test_for_changes=true) {
            var total = 0;
            var parsed_input;

            // Parse the input of each month entry and add it to the total sum
            for (var i = this.months.length - 1; i >= 0; i--) {
                parsed_input = parseFloat(this.months[i].input);
                this.months[i].parsed_input = parsed_input || 0;

                if(i >= this.order_plan_material.order_plan.startFrom) {
                    total += this.months[i].parsed_input;
                }
            }

            this.total_estimate_calculated = total;

            // Update the percentages
            for (var i = this.months.length - 1; i >= 0; i--) {
                this.months[i].percentage = 100 * this.months[i].parsed_input / total;
            }

            // Calculate the revenue totals
            this.updateRevenue();

            // Compare JSON Serialization to stored JSON serialization
            // if it's different save the entry.
            var JSONafter = JSON.stringify(this.toJson());
            if(this.order_plan.save_changes && test_for_changes && this.JSONbefore != JSONafter) {
                this.scheduleSave();
            }
            this.JSONbefore = JSONafter; // Save JSON to compare against for next run

            // Once totals have changed, update totals on the parent component.
            this.order_plan_material.updateTotals();
            this.order_plan_material.refreshLayout();
        }

        updateRevenue() {
            var unit_cost = parseFloat(this.unit_cost) || 0;

            var total_estimated_revenue = 0;
            var total_scheduled_revenue = 0;

            for (var i = 0; i < this.months.length; i++) {
                var month = this.months[i];
                month.calculated_revenue = month.parsed_input * unit_cost;
                month.scheduled_revenue = month.scheduled * unit_cost;

                if(i >= this.order_plan_material.order_plan.startFrom) {
                    total_estimated_revenue += month.calculated_revenue;
                    total_scheduled_revenue += month.scheduled_revenue;
                }
            }

            this.total_revenue_estimated = total_estimated_revenue;
            this.total_revenue_scheduled = total_scheduled_revenue;

            this.order_plan_material.updateRevenue();
        }

        setForecastData(forecast_data) {

            if(!forecast_data.periods) return;

            forecast_data.periods.forEach((item, index) => {
                this.months[index].scheduled = item.total;
            });

            this.total_scheduled = forecast_data.total;
            this.order_plan_material.reloadForecastData();
        }

        removeEntry() {
            var _this = this;
            var plant = this.order_plan_material.order_plan.plant;
            var plan = this.order_plan_material.order_plan.id;
            var material = this.order_plan_material.material_id;
            var entry = this.id;

            var url = `/plant/${plant}/order_plan/${plan}/material/${material}/entry/${entry}/delete/`;

            $http.delete(url).success(function () {
                var index = _this.order_plan_material.entries.indexOf(_this);
                _this.order_plan_material.entries.splice(index, 1);

                _this.order_plan_material.reloadForecastData();
            });
        }

        scheduleSave() {
            if(this.scheduledSave) {
                $timeout.cancel(this.scheduledSave);
            }

            this.scheduledSave = $timeout(() => {
                this.saveEntry();
            }, 1000);
        }

        saveEntry() {
            var plant = this.order_plan_material.order_plan.plant;
            var plan = this.order_plan_material.order_plan.id;
            var material = this.order_plan_material.material_id;
            var entry = this.id;

            var url = `/plant/${plant}/order_plan/${plan}/material/${material}/entry/${entry}/`;
            var data = this.toJson();

            if(!this.hasEstimates) {
                data.estimates = [];
            }

            return $http({
                method: 'PATCH',
                url: url,
                data: data
            }).success((data) => {
                console.log('saved updated entry', data);
            }).error((e) => {
                console.error('error', e);
            })
        }

        toJson(){
            var _this = this;
            var entry_estimates = _this.months.map((month, i) => { return {
                value: month.input,
                month: i + 1
            }});
            return {
                total_estimate: _this.total_estimate_calculated,
                unit_cost: this.unit_cost,
                estimates: entry_estimates
            };
        }

        loadFromJson(json_data){
            var _this = this;

            this.id = json_data.id;
            this.customer_name = json_data.customer_name;
            this.unit_cost = json_data.unit_cost;
            this.setForecastData(json_data.scheduled);

            if(json_data.estimates.length > 0) {
                this.hasEstimates = true;
            }
            json_data.estimates.map((estimate) => {
                _this.months[estimate.month - 1].input = estimate.value
            });

            this.updateTotals(false);
        }
    }

    class OrderPlanMaterialEntryVarious extends OrderPlanMaterialEntry {
        constructor(order_plan_material, json_data={}) {
            super(order_plan_material, json_data);
            this.is_various = true;
        }
        removeEntry() {
            throw "Can not delete various entry";
        }
    }

    class OrderPlanMaterial {
        constructor(order_plan, json_data) {
            this.order_plan = order_plan;

            this.entries = [];

            this.totals = [];
            this.revenue_totals = [];
            this.total_estimated = -1;
            this.total_scheduled = -1;
            this.total_revenue_estimated = -1;
            this.total_revenue_scheduled = -1;

            this.loadFromJson(json_data);
        }

        createEntry(customer_name) {
            var plant = this.order_plan.plant;
            var plan = this.order_plan.id;
            var material = this.material_id;
            $http({
                method: 'POST',
                url: `/plant/${plant}/order_plan/${plan}/material/${material}/entry/create/`,
                data: {
                    customer_name: customer_name,
                    total_estimate: 0,
                    estimates: []
                }
            }).success((json_data) => {
                this.loadFromJson(json_data);
            });
        }

        getAverageCost(){
            return Math.round(this.total_revenue_estimated / this.total_estimated) || 0;
        }

        updateTotals() {
            var total_estimated = 0;
            var total_scheduled = 0;
            var total_month_estimated;
            var total_month_scheduled;

            for (var i = 0; i < 12; i++) {
                total_month_estimated = 0;
                total_month_scheduled = 0;
                for (var j = this.entries.length - 1; j >= 0; j--) {
                    total_month_estimated += this.entries[j].months[i].parsed_input;
                    total_month_scheduled += this.entries[j].months[i].scheduled;
                }

                // Add totals for various field
                if(this.various) {
                    total_month_estimated += this.various.months[i].parsed_input;
                    total_month_scheduled += this.various.months[i].scheduled;
                }

                this.totals[i] = {
                    estimated: total_month_estimated,
                    scheduled: total_month_scheduled,
                    scheduled_percentage: Math.round(100 * total_month_scheduled / total_month_estimated),
                    index: i
                };

                if(i >= this.order_plan.startFrom) {
                    total_estimated += total_month_estimated;
                    total_scheduled += total_month_scheduled;
                }
            }

            this.total_estimated = total_estimated;
            this.total_scheduled = total_scheduled;
            this.order_plan.updateGrandtotals()
        }

        updateRevenue() {
            var total_estimated = 0;
            var total_scheduled = 0;

            var total_month_estimated;
            var total_month_scheduled;

            for (var i = 0; i < 12; i++) {
                total_month_estimated = 0;
                total_month_scheduled = 0;
                for (var j = this.entries.length - 1; j >= 0; j--) {
                    total_month_estimated += this.entries[j].months[i].calculated_revenue;
                    total_month_scheduled += this.entries[j].months[i].scheduled_revenue;
                }

                // Add totals for various field
                if(this.various) {
                    total_month_estimated += this.various.months[i].calculated_revenue;
                    total_month_scheduled += this.various.months[i].scheduled_revenue;
                }

                this.revenue_totals[i] = {
                    estimated: total_month_estimated,
                    scheduled: total_month_scheduled,
                    scheduled_percentage: Math.round(100 * total_month_scheduled / total_month_estimated),
                    index: i
                };

                if(i >= this.order_plan.startFrom) {
                    total_estimated += total_month_estimated;
                    total_scheduled += total_month_scheduled;
                }
            }

            this.total_revenue_estimated = total_estimated;
            this.total_revenue_scheduled = total_scheduled;
            this.order_plan.updateGrandtotals()
        }

        reloadForecastData() {
            //this.entries[this.entries.length - 1].loadForecastData();
        }

        refreshLayout() {
            this.order_plan.refreshLayout();
        }

        loadFromJson(json_data) {

            var _this = this;

            this.id = json_data.id;
            this.material_id = json_data.material;
            this.material_name = json_data.material_name;
            this.various = new OrderPlanMaterialEntryVarious(_this, json_data.various);
            this.entries = json_data.entries.map((entry) => {
                return new OrderPlanMaterialEntry(_this, entry);
            });
            this.updateTotals();
            this.updateRevenue();
        }
    }

    class OrderPlanEstimation {
        constructor(order_plan, json_data) {
            this.order_plan = order_plan;

            this.estimates = []; // The estimates
            if(!json_data) {
                this.generateEstimates();
            } else {
                this.fromJson(json_data);
            }
        }

        generateEstimates() {
            this.estimates = ESTIMATE_PRESETS.map((e) => {
                return {
                    input: e,
                    parsed_input: 0,
                    percentage: 0
                };
            });
            this.updateEstimatePercentages();
        }

        updateEstimatePercentages() {
            var total = 0;

            for (var i = this.estimates.length - 1; i >= 0; i--) {
                this.estimates[i].parsed_input = parseFloat(this.estimates[i].input) || 0;
                total += this.estimates[i].parsed_input;
            }

            this.estimates.total = total;

            for (var i = this.estimates.length - 1; i >= 0; i--) {
                this.estimates[i].percentage = 100 * this.estimates[i].parsed_input / total;
            }
        }

        updateEstimates(force=false){
            if(this.order_plan.id) {
                // Compare JSON Serialization to stored JSON serialization
                // if it's different save the entry.
                var new_estimates = JSON.stringify(this.toJson());
                if(force ||this.previous_estimates != new_estimates) {
                    this.scheduleSave();
                }
                this.previous_estimates = new_estimates; // Save JSON to compare against for next run
            }
        }

        saveEstimates() {
            var estimates = this.toJson();
            var plant = this.order_plan.plant;
            var plan = this.order_plan.id;

            return $http({
                method: 'PUT',
                data: estimates,
                url: `/plant/${plant}/order_plan/${plan}/sales_distribution/`
            });
        }

        scheduleSave() {
            if(this.scheduledSave) {
                $timeout.cancel(this.scheduledSave);
            }

            this.scheduledSave = $timeout(() => {
                this.saveEstimates();
            }, 1000);
        }

        toJson() {
            var _this = this;
            return _this.estimates.map((estimate, index) => { return { value: estimate.parsed_input, month: index+1, id: estimate.id } });
        }

        fromJson(json_data) {
            this.estimates = json_data.map((obj, i) => {
                return {
                    input: obj.value,
                    parsed_input: obj.value,
                    percentage: 0,
                    id: obj.id
                }
            });
            this.updateEstimatePercentages();
        }
    }

    class OrderPlan {
        constructor(json_data={}) {
            // Information about the plan
            this.save_changes = true;

            this.materials = []; // List of materials
            this.months = []; // The month headings for the titles

            this.totals = {
                quantity: -1,
                revenue: -1
            };

            this.startFrom = 0;

            this.generateMonths();


            this.loadFromJson(json_data);
        }

        generateMonths() {
            this.months = [];
            for (var i = this.startFrom; i <= 12 - 1; i++) {

                this.months.push(
                    moment({year: this.year, month: i, day: 1})
                );
            }
        }

        refreshLayout() {
            $timeout(() => {
                angular.element(window).trigger('resize')
            });
        }

        updateTotals(month){
            this.startFrom = month;

            this.materials.forEach((material) => {
                material.updateTotals();
                material.updateRevenue();

                material.various.updateTotals(false);
                material.various.updateRevenue();

                material.entries.forEach((entry) => {
                    entry.updateTotals(false);
                    entry.updateRevenue();
                });
            });

            this.updateGrandtotals()
            this.refreshLayout();
        }

        updateGrandtotals() {
            this.totals = this.materials.reduce((left, right) => {
                left.quantity += right.total_estimated;
                left.revenue += right.total_revenue_estimated;
                return left;
            }, {quantity: 0, revenue: 0});
        }

        addMaterial(material) {
            var plant = this.plant;
            var plan = this.id;

            return $http({
                method: 'POST',
                url: `/plant/${plant}/order_plan/${plan}/material/create/`,
                data: {
                    material: material
                }
            }).success((json_data) => {
                this.loadFromJson(json_data);

                this.materials.forEach((material_obj) => {

                    if(material_obj.material_id == material) {
                        material_obj._newly_added = true;
                    }
                })

            });
        }

        deleteMaterial(material_id) {
            var plant = this.plant;
            var plan = this.id;

            return $http({
                method: 'DELETE',
                url: `/plant/${plant}/order_plan/${plan}/material/${material_id}/delete/`
            });
        }

        delete(){
            var plant = this.plant;
            var plan = this.id;

            return $http({
                method: 'DELETE',
                url: `/plant/${plant}/order_plan/${plan}/delete/`
            });
        }

        refreshData(){
            var _this = this;
            var url = `/plant/${_this.plant}/order_plan/${_this.id}/`;

            return $http({
                method: 'GET',
                url: url
            }).then((result) => {
                this.loadFromJson(result.data);
            });
        }

        toJson(){
            var _this = this;

            return {
                description: _this.description,
                year: _this.year,
                sales_distribution: _this.sales_distribution.toJson()
            };
        }

        loadFromJson (json_data){

            var _this = this;

            this.id = json_data.id;
            this.plant = json_data.plant;
            this.year = json_data.year;

            this.description = json_data.description;

            this.sales_distribution = new OrderPlanEstimation(this, json_data.sales_distribution);

            this.materials = (json_data.materials || []).map((material) => {
                return new OrderPlanMaterial(_this, material)
            });
        }
    }

    var OrderPlannerSvc = {

        list (plant) {
            var url = `/plant/${plant}/order_plans/`;
            return $http({
                method: 'GET',
                url: url
            });
        },

        delete (plant, plan_id){
            return $http({
                method: 'DELETE',
                url: `/plant/${plant}/order_plan/${plan_id}/delete/`
            });
        },

        get: function (plant, id) {
            var order_plan;
            var get_deferred = $q.defer();

            var url = `/plant/${plant}/order_plan/${id}/`;

            $http({
                method: 'GET',
                url: url
            }).then((result) => {
                var order_plan = new OrderPlan(result.data);
                get_deferred.resolve(order_plan);
            });

            return get_deferred.promise;
        },

        getNew: function (plant, obj) {
            var deferred = $q.defer();
            obj.plant = plant;
            var order_plan = new OrderPlan(obj);
            deferred.resolve(order_plan);
            return deferred.promise;
        },

        create: function(order_plan){
            var create_deferred = $q.defer();

            var url = `/plant/${order_plan.plant}/order_plan/new/`;
            $http({
                method: 'POST',
                url: url,
                data: order_plan.toJson()
            }).then((result) => {
                return OrderPlannerSvc.get(order_plan.plant, result.data.id).then(function (order_plan) {
                    create_deferred.resolve(order_plan);
                });
            });

            return create_deferred.promise;
        },

        update: function(order_plan){
            return;
        },

        updateEntry: function(plant, order_plan) {

        }
    };
    return OrderPlannerSvc;

}];
